export class FraudCase {
  blacklistComment =  ''
  blacklistTransactionId = 0
  blacklisted = false
  blacklistedDate = 0
  createdDate = 0

  hasChargebacks = false
  hasStolenCards = true
  id = 0
  lastUpdateDate = 0

  creditCards: FraudCaseCreditCard[] = []
  msisdns: FraudCaseMsisdn[] = []
  paypalPayers: FraudCasePaypalPayerId[] = []
  users: FraudCaseUserId[] = []
}

export class FraudCaseItem {
  createdDate = 0
  fraudCaseId = 4834
  id =  0
  level =  1
  pardoned = false
  whyAdded = ''
  whyPardoned = ''
}

export class FraudCaseMsisdn extends FraudCaseItem{
  msisdn = ''
}

export class FraudCaseCreditCard extends FraudCaseItem{
  creditCardToken = ''
}

export class FraudCaseUserId extends FraudCaseItem{
  userId = ''
}

export class FraudCasePaypalPayerId extends FraudCaseItem{
  paypalPayerId = ''
}

